import ConsentController from '@humandigital-agency/consent-controller';

document.addEventListener('DOMContentLoaded', () => {
  new ConsentController(); // Initialize controller when DOM is fully loaded
});
